import React, {useEffect} from "react";
import {Field} from "formik";
import loading from "@images/pulse-loader.svg";

export function CoveragesCard(props) {

    const isAuthenticated = localStorage.getItem("isAuthenticated");

    useEffect(() => {
        if (props.formikValues.material_damages === null)
            props.formikValues.material_damages = '3';
        if (props.formikValues.total_thefts === null)
            props.formikValues.total_thefts = '5';
        if (props.planTypes.length === 1) {
            props.formikValues.coverage_plan = props.planTypes[0]?.id;
            props.formikValues.material_damages = '5'; //APLICA PARA BANJERCITO
            props.formikValues.total_thefts = '10'; //APLICA BANJERJCITO
            props.formikValues.payment = props.paymentMethods[0]?.id;
        }
    }, [props.planTypes,props.formikValues.coverage_plan, props.adaptableUdi])

    return (
        <>
            <div className="col-sm-12 col-lg-3">
                <div className="container card-border py-5"
                     style={{minHeight: '36rem', marginTop: '2rem'}}>
                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            <label>Paquetes de Coberturas:</label>
                            <select name="coverage_plan" onClick={()=>{/*props.obtainCoveragesFromPackage(event)*/}}
                                    onChange={props.handleChange} value={props.formikValues.coverage_plan}
                                    className="form-control form-select" required>
                                <option value="" selected disabled
                                        onChange={props.handleChange}>Seleccionar...
                                </option>
                                {props.planTypes.map(option => (
                                    <option key={option.id} value={option.id}
                                            onChange={props.handleChange}>
                                        {option.description}
                                    </option>))}
                            </select>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 mt-3"
                             hidden={props.formikValues.coverage_plan != 5 && props.formikValues.coverage_plan != 4 || props.planTypes.length === 1}>
                            <label>Deducible daños materiales:</label>
                            <br/>
                            <div className="btn-group radio-toolbar-sekura2 col-12" role="group"
                                 aria-labelledby="radio-group-DM">
                                <Field type="radio" className="btn-check" name="material_damages"
                                       id="three_porcent" autoComplete="off" value="3"/>
                                <label className="btn btn-outline-sekura"
                                       htmlFor="three_porcent"> 3% </label>
                                <Field type="radio" className="btn-check" name="material_damages"
                                       id="five_porcent" autoComplete="off" value="5"/>
                                <label className="btn btn-outline-sekura"
                                       htmlFor="five_porcent"> 5% </label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 mt-3"
                             hidden={props.formikValues.coverage_plan == 2 || !props.formikValues.coverage_plan || props.planTypes.length === 1}>
                                <label>Deducible robo total:</label>
                                <br/>
                                <div className="btn-group radio-toolbar-sekura2 col-12" role="group"
                                     aria-labelledby="radio-group-RT">
                                    <Field type="radio" className="btn-check" name="total_thefts"
                                           id="porcent_five" autoComplete="off" value="5"
                                           required/>
                                    <label className="btn btn-outline-sekura"
                                           htmlFor="porcent_five"> 5% </label>
                                    <Field type="radio" className="btn-check" name="total_thefts"
                                           id="porcent_ten" autoComplete="off" value="10"/>
                                    <label className="btn btn-outline-sekura"
                                           htmlFor="porcent_ten"> 10% </label>
                                </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 mt-3">
                            <img className="col-12" src={loading}
                                 alt="img-insurance" style={{height: '14vh'}} hidden={!props.showLoadingCoverages}/>
                            <ul className="list-group border-bottom border-top" hidden={!props.showCoverages}>
                                {props.coveragesPackage.map((option => (
                                    <small className="coverages-text"
                                           key={option.coverageId}
                                           onChange={props.handleChange}>
                                        {'-' + option.description}
                                    </small>)))}
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">
                                <label>Formas de pago:</label>
                                <select name="payment" value={props.formikValues.payment}
                                        onChange={props.handleChange}
                                        className="form-control"
                                        required>
                                    <option value="" selected disabled
                                            onChange={props.handleChange}>Seleccionar...
                                    </option>
                                    {props.paymentMethods.map(option => (
                                        <option key={option.id}
                                                value={option.id}
                                                onChange={props.handleChange}>
                                            {option.description}
                                        </option>))}
                                </select>
                            </div>
                        </div>
                    </div>
                    {/*Integration to flag Udi Adaptable*/}
                    {props.adaptableUdi
                        ?
                        <div className="row">
                            <div className="col-12 mt-2">
                                <label>UDI:</label>
                                <select name="udi" value={props.formikValues.udi}
                                onChange={props.handleChange} className="form-control"
                                        required>
                                    <option value="" selected disabled
                                            onChange={props.handleChange}>Seleccionar...
                                    </option>
                                    {/**UDI 20% NOTA: SE CAMBIARA POR UN SERVICIO*/}
                                    <option key="3"
                                            value="3"
                                            onChange={props.handleChange}>
                                        UDI 20%
                                    </option>
                                    {/**UDI 20% NOTA: SE CAMBIARA POR UN SERVICIO*/}


                                    {/**UDI 15% NOTA: SE CAMBIARA POR UN SERVICIO*/}
                                    <option key="2"
                                            value="2"
                                            onChange={props.handleChange}>
                                        UDI 15%
                                    </option>
                                    {/**UDI 20% NOTA: SE CAMBIARA POR UN SERVICIO*/}

                                    {/**UDI 15% NOTA: SE CAMBIARA POR UN SERVICIO*/}
                                    <option key="1"
                                            value="1"
                                            onChange={props.handleChange}>
                                        UDI 10%
                                    </option>
                                    {/**UDI 20% NOTA: SE CAMBIARA POR UN SERVICIO*/}
                                </select>
                            </div>
                        </div>
                        :null}
                </div>
            </div>
        </>
    );
}